import {
  Component,
  OnInit,
  Input,
  OnChanges,
  EventEmitter,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../core/services/auth.service';

@Component({
    selector: 'app-progress-bar-button',
    templateUrl: './progress-bar-button.component.html',
    styleUrls: ['./progress-bar-button.component.css'],
    standalone: false
})
export class ProgressBarButtonComponent implements OnInit, OnChanges {
  @Input() progressBarPercent: number;
  @Input() actionFinalized: boolean;
  @Input() buttonTextKey: string;
  @Input() disabledCondition: boolean;
  @Input() widthPercentage: number;
  @Input() heightPercentage: number;
  @Input() marginStyle: string;
  @Output() perform: EventEmitter<any> = new EventEmitter<any>();

  progressBarShown: boolean;
  get isImpersonated() {
    return this.authService.isImpersonated();
  }
  get buttonText(): string {
    if (this.progressBarShown) {
      return `${this.progressBarPercent}%`;
    }
    let buttonText: string;
    this.translateService
      .get(this.buttonTextKey)
      .subscribe(t => (buttonText = t));
    return buttonText;
  }

  get progressValue(): string {
    return `${this.progressBarPercent}%`;
  }

  get width(): string {
    return `${this.widthPercentage}%`;
  }

  get height(): string {
    return `${this.heightPercentage}%`;
  }

  get margin(): string {
    return `${this.marginStyle}`;
  }

  constructor(
    private translateService: TranslateService,
    private authService: AuthService,
  ) {}

  ngOnInit() {}

  ngOnChanges(): void {
    if (this.actionFinalized) {
      this.progressBarShown = false;
    } else {
      this.progressBarShown = true;
    }
  }

  performAction(event: any): void {
    this.perform.emit(event);
  }
}
